import { useEffect } from "react";
import { createPortal } from "react-dom";

const InfoDialog = ({
  open,
  title,
  message,
  confirmLabel = "OK",
  mark = "✉",
  onClose,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="info-dialog-root">
      <div
        className="info-dialog-overlay"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="info-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="info-dialog-title"
        aria-describedby="info-dialog-desc"
      >
        <span className="info-dialog-mark" aria-hidden="true">
          {mark}
        </span>
        <h2 id="info-dialog-title" className="info-dialog-title">
          {title}
        </h2>
        <p id="info-dialog-desc" className="info-dialog-message">
          {message}
        </p>
        <div className="info-dialog-actions">
          <button type="button" className="info-dialog-confirm" onClick={onClose}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default InfoDialog;
